import styled from "@emotion/styled";
import { Button, CircularProgress } from "@mui/material";

export const ButtonStyled = styled(Button, {
  shouldForwardProp: prop => prop !== "addStyles" && prop !== "small",
})`
  font-size: 18px;
  font-weight: 600;
  text-transform: none;
  min-width: min-content;
  box-shadow: none;
  height: ${({ small }) => (small ? "48px" : "70px")};
  border-radius: ${({ small }) => (small ? "12px" : "50px")};
  border: ${({ small }) => (small ? "none" : "1px solid #e3ffa0")};

  &:hover {
    background-color: #a2e902;
    border-color: #c0f052;
  }

  &:active {
    background-color: #78ac01;
    border-color: #a3c751;
  }

  @media (max-width: ${p => p.theme.screenSizes.mdMax}) {
    ${({ small }) =>
      !small &&
      `
      height: 48px;
      font-size: 16px;
      line-height: 20px;
    `}
  }

  ${props => props.addStyles}
`;

export const CircularProgressStyled = styled(CircularProgress)`
  margin-left: 10px;
`;
